var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BoletinView',{attrs:{"fetch-path":"settlement","toolbar-title":"Liquidación","type-label":"Tipo de liquidación","descripion-label":"Observación","period":""}})}
var staticRenderFns = []

export { render, staticRenderFns }